<template></template>

<script>
import { isDefined } from "../../../../../ceres/helper/utils";
import { dynamicItemListItemDefault } from "./DynamicItemListItemMixin";

export default {
	mixins: [dynamicItemListItemDefault],

	props: {
		settings: {
			type: Object,
			default: () => {}
		}
	},

	data() {
		return {
			attributeValueIDList: [],
			categoryId: 0
		};
	},

	methods: {
		onlyUnique: function (value, index, self) {
			return self.indexOf(value) === index;
		},

		getItemListParams() {
			if (isDefined(this.currentVariation.attributes) && this.currentVariation.attributes.length > 0) {
				this.attributeValueIDList = this.currentVariation.attributes
					.filter((attribute) => attribute.attributeId === this.settings.attrCross.attributeId)
					.map((attribute) => attribute.valueId);
				this.categoryId = this.currentVariation.defaultCategories
					.filter((category) => category.plentyId === App.plentyId)
					.map((category) => category.id);

				if (this.categoryId.length > 0) this.categoryId = this.categoryId[0];
			}
		},

		initializeList: function (isUpdate = false) {
			if (this.settings.attrCross !== null) {
				this.getItemListParams();
				const attributeValueIDList = this.attributeValueIDList.filter(this.onlyUnique);

				this.$emit("init", {
					params: {
						attributeValueIds: attributeValueIDList ?? [],
						originCategoryId: this.categoryId ?? "",
						variationId: this.currentVariation.variation.id ?? ""
					},
					isUpdate
				});
			}
		}
	}
};
</script>
